import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function FirstJobGuide() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="How to Get Your First Job (2026 Guide)"
        description="Learn how to get your first job with no experience. Step-by-step guide to landing your first role faster."
        canonical="https://employpilot.com/first-job-guide"
      />


      <h1>How to Get Your First Job</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Getting your first job can feel overwhelming — but with the right steps,
        you can land one faster than you think.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Start Your Resume
      </button>

      <h2 style={{ marginTop: "40px" }}>Step 1: Build a Resume</h2>
      <p>
        Even without experience, your resume should highlight skills and education.
      </p>

      <h2>Step 2: Apply Consistently</h2>
      <p>
        Apply to multiple jobs daily to increase your chances.
      </p>

      <h2>Step 3: Prepare for Interviews</h2>
      <p>
        Practice common interview questions and answers.
      </p>

      <h2>Step 4: Stay Consistent</h2>
      <p>
        Rejections are normal — keep going.
      </p>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need a resume?{" "}
        <Link to="/ai-resume-builder">
          Build one here
        </Link>
      </p>

      <p>
        No experience?{" "}
        <Link to="/resume-no-experience">
          Start here
        </Link>
      </p>

      <p>
        Interview prep?{" "}
        <Link to="/interview-questions">
          Practice questions
        </Link>
      </p>

      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Your Career Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>

      <h2 style={{ marginTop: "60px" }}>FAQs</h2>

      <h3>How long does it take to get a first job?</h3>
      <p>It varies, but consistency speeds up results.</p>

      <h3>What if I get rejected?</h3>
      <p>Keep applying — rejection is part of the process.</p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default FirstJobGuide;